export default __webpack_public_path__ + "static/media/photo--sm--84.ff1b99a0.jpg";